import { isDefinedString } from "et3-type-guards";
import getApproveRejectStore from "../../../../../../../stores/approval-reject-store";
import { TDescriptionType } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import NonePendingResolve from "./NonePendingResolve";
import PendingResolve from "./PendingResolve";
import {
  DESCRIPTION_SOLVE_GAP,
  DESCRIPTION_SOLVE_HEIGHT
} from "../descriptions/descriptions-constants";

const DescriptionDataSolve = withLiteObserverAndTheme<{
  userID: number;
  userUUID: string;
  description: string;
  descriptionID: number;
  descriptionStatus: string;
  descriptionType: TDescriptionType;
  isPendingDescription: boolean;
}>((props) => {
  const {
    theme,
    userID,
    userUUID,
    description,
    descriptionID,
    descriptionStatus,
    descriptionType,
    isPendingDescription
  } = props;
  const { colors, unitX } = theme;

  return isDefinedString(description) ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-end"
      alignItems="center"
      withShadow={false}
      width={0}
      height={DESCRIPTION_SOLVE_HEIGHT}
      color={colors.all.transparent}
      style={{ width: "100%", gap: DESCRIPTION_SOLVE_GAP * unitX }}
      onClick={() => {}}
    >
      <PendingResolve
        dataStatusIsPending={isPendingDescription}
        acceptDataCallback={() => {
          return getApproveRejectStore().approveUserDescription(
            descriptionID,
            userID,
            userUUID,
            "USER_ADVANCED",
            descriptionType,
            true,
            ""
          );
        }}
        rejectDataCallback={() => {
          return getApproveRejectStore().rejectUserDescription(
            descriptionID,
            userID,
            userUUID,
            "USER_ADVANCED",
            descriptionType,
            true,
            ""
          );
        }}
      />
      <NonePendingResolve
        dataStatusIsPending={isPendingDescription}
        changeDataStatus={() => {
          if (descriptionStatus === "REJECTED") {
            return getApproveRejectStore().approveUserDescription(
              descriptionID,
              userID,
              userUUID,
              "USER_ADVANCED",
              descriptionType,
              false,
              ""
            );
          }
          if (descriptionStatus === "APPROVED") {
            return getApproveRejectStore().rejectUserDescription(
              descriptionID,
              userID,
              userUUID,
              "USER_ADVANCED",
              descriptionType,
              false,
              ""
            );
          }
          return null;
        }}
      />
    </ET3Div>
  ) : null;
});

export default DescriptionDataSolve;
